import $ from 'jquery';

export const init_product_link_click = () => {
	$( '.product_link' ).on( 'click', ( e ) => {
		e.preventDefault();
		window.location.href = $( e.target ).attr( 'data-url' );
	} );
}

init_product_link_click();